import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { plotShort, plotNovel } from '@/mocks/drama';

const tabs = [
  { key: 'short', label: '短剧版', data: plotShort },
  { key: 'novel', label: '小说版', data: plotNovel },
];

export default function PlotSection() {
  const [active, setActive] = useState('short');
  const current = tabs.find((t) => t.key === active) ?? tabs[0];

  return (
    <section id="plot" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="Story structure"
            title="完整版剧情脉络解析"
            desc="同一条主线，短剧与小说的呈现节奏并不相同。切换下方标签，分别查看两种版本的幕次结构与关键转折。"
          />
          <div className="inline-flex shrink-0 rounded-full bg-background-200 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-5 py-2 text-sm font-label transition-colors ${
                  active === tab.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12">
          {current.data.map((act, index) => (
            <div key={act.title} className="relative flex gap-5 md:gap-8">
              <div className="flex flex-col items-center">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-accent-400 bg-background-50 font-heading text-sm font-bold text-primary-600">
                  {String(index + 1).padStart(2, '0')}
                </div>
                {index < current.data.length - 1 && (
                  <div className="w-px flex-1 bg-background-300" />
                )}
              </div>

              <div className="flex-1 pb-10">
                <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-label font-medium text-secondary-900">
                      {act.no}
                    </span>
                    <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                      {act.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-sm font-medium text-primary-600">{act.summary}</p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{act.detail}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {act.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full border border-accent-300 bg-accent-50 px-3 py-1 text-xs font-label text-accent-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}